import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { TextInput, Flex, Label, Popup } from '@leverege/ui-elements'
import { Project } from '@leverege/api-redux'
import { Section, LabelGroup } from '~/views'
import BaseAttributeEditor from './BaseAttributeEditor'
import { UpdaterSelector, UpdaterFactory } from '~/editors/updaters'

import S from './style.css'

class EnumAttributeEditor extends React.Component {

  static propTypes = {
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = BaseAttributeEditor.ChangePath.bind( this )
    this.onUpdaterChange = BaseAttributeEditor.OnUpdaterChange.bind( this )
    this.onSelectUpdater = this.onSelectUpdater.bind( this )
  }

  onSetEnum = ( { data } ) => {
    this.changePath( 'enumType', data )
  }

  onSelectUpdater( updater ) {
    this.changePath( 'sim/updater', updater, false )
  }

  componentDidMount() {
    const { dispatch, blueprint } = this.props
    dispatch( Project( blueprint.projectId ).enums().list() )
  }

  getEnumValues( enums ) {
    if ( !enums ) return null

    const values = Object.values( enums ).map( prjEnum => (
      <Popup.Item
        key={prjEnum.type}
        eventData={prjEnum.type}
        onClick={this.onSetEnum}>
        {prjEnum.name}
      </Popup.Item>
    ) )

    values.unshift(
      <Popup.Item
        key="null"
        eventData={null}
        onClick={this.onSetEnum}>
        Clear (set to null)
      </Popup.Item>
    )
    return values
  }

  render() {
    const { attribute : attr, blueprint, enums } = this.props
    
    if ( attr == null ) {
      return <div />
    }
    const uProps = { attribute : attr, blueprint, onChange : this.onUpdaterChange }
    const updater = UpdaterFactory.createEditor( attr.sim && attr.sim.updater, uProps )

    return (
      <div>
        <BaseAttributeEditor {...this.props} />
        <Section header="Enum Options">
          <Flex className={S.pad} variant="vSpace" direction="column" align="stretch">
            <LabelGroup>
              <Label>Enum Type</Label>
              <Popup
                title={attr?.enumType || 'Set Enum Value'}>
                {this.getEnumValues( enums )}
              </Popup>
            </LabelGroup>
          </Flex>
        </Section>
        <Section header="Simulation">
          <Flex className={S.pad} variant="vSpace" direction="column" align="stretch">
            <LabelGroup>
              <Label>Initial Value</Label>
              <TextInput
                hint="Initial Value..." 
                value={attr?.sim?.initialValue}
                onChange={( { value } ) => this.changePath( 'sim/initialValue', value )} />
            </LabelGroup>
            {
              UpdaterSelector.hasCreators( attr ) && 
              (
                <LabelGroup>
                  <Label>Update With</Label>
                  <UpdaterSelector attribute={attr} updater={attr?.sim?.updater} onSelect={this.onSelectUpdater} />
                </LabelGroup>
              )
            }
            {updater}
          </Flex>
        </Section>
      </div>
    ) 
  }
}

export default connect(
  ( state, props ) => {
    const { blueprint : { projectId } } = props
    return {
      enums : state?.enums?.[projectId]?.enums
    }
  }
)( EnumAttributeEditor )
